import alt from '@/utils/alt';

class NominationStore {
  constructor() {
    this.nomination = false;
  }
}

export default alt.createStore(NominationStore, 'NominationStore');
